<div class="modal fade my-bs-modal " id="spinner-modal" tabindex="-1" aria-labelledby="modalSpinnerLabel"
    aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content rounded shadow-lg">
            <div class="modal-header">
                <h6 class="modal-title fw-semibold text-wrap text-center" id="modalSpinnerLabel">
                    {{ potential ? ('spinner-modal.loadSpinnerPotential' | translate)
                    : ('spinner-modal.loadSpinnerCalc' | translate) }}
                </h6>
            </div>
            <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                    <div class="spinner-border text-info mb-3" style="width: 4rem; height: 4rem;" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="text-muted fs-6">
                        {{ 'spinner-modal.infoSpinner' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>